import React from "react";
import "./styles.css";
import LogoTramy from "../../../assets/logos/logo_blanco_tramy.png";
import Anchor from "../anchor";
import { ReactComponent as PhoneIcon } from "../../../assets/icons/phone.svg";
import { calendlyTramy, whatsappTramy } from "../../../constants/urls";
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <div className="navbar">
      <NavLink activeClassName="active" to="/">
        <img className="navbar__logo" src={LogoTramy} alt="logo of Tramy" />
      </NavLink>
      <input class="menu-button" type="checkbox" id="menu-button" />
      <label class="menu-icon" for="menu-button">
        <span class="navicon"></span>
      </label>
      <ul class="navbar__menu">
        {/* Navlinks Start */}
        <li>
          <NavLink className="navlink" to="/about">
            Nosotros
          </NavLink>
        </li>
        <li>
          <NavLink className="navlink" to="/pricing">
            Precios
          </NavLink>
        </li>
        <li>
          <NavLink className="navlink" to="/allies">
            Aliados
          </NavLink>
        </li>
        <li>
          <NavLink className="navlink" to="/resources">
            Recursos
          </NavLink>
        </li>

        {/* Navlinks End */}

        {/* Links Start */}
        <li>
          <Anchor
            link={whatsappTramy}
            text={"(+51) 902 462 575"}
            icon={<PhoneIcon />}
          />
        </li>
        <li className="demo-button">
          <Anchor link={calendlyTramy} text={"Solicitar Demostración"} />
        </li>
        {/* Links End */}
      </ul>
    </div>
  );
}

export default Navbar;
